// extracted by mini-css-extract-plugin
module.exports = {"SepTimePie":"SepTimePie_SepTimePie__v7jvB"};